/* 布局 */
//前台
import Layout from "@views/layout";

const attachmentRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
        {
        path: "attachment/list",
        name: "ATTACHMENT",
        meta: {
            title: "",
        },
        component: () => import("@views/business/attachment/index.vue"),
    },
        ],
};

export default attachmentRouter;
